'use client'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { IconButton } from '@mui/material'
// ----------------------------------------------------------------------

interface PasswordToggleIconProps {
  showPassword: boolean
  onToggle: () => void
}

export function PasswordToggleIcon({ showPassword, onToggle }: PasswordToggleIconProps) {
  return (
    <IconButton onClick={onToggle} edge="end" color="primary">
      {showPassword ? (
        <VisibilityOutlinedIcon fontSize="small" />
      ) : (
        <VisibilityOffOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  )
}
